<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-body class="pt-50">
        <b-row>
          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="经纪姓名" style="margin-bottom: 0;">
            <b-form-input
              v-model="searchParams.brokerName"
              class="d-inline-block"
              placeholder="经纪姓名"
            />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="客户联系人" style="margin-bottom: 0;">
            <b-form-input
              v-model="searchParams.contactsName"
              class="d-inline-block"
              placeholder="客户联系人"
            />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="客户电话" style="margin-bottom: 0;">
            <b-form-input
              v-model="searchParams.contactsPhone"
              class="d-inline-block"
              placeholder="客户电话"
            />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="客户名称" style="margin-bottom: 0;">
            <b-form-input
              v-model="searchParams.customerName"
              class="d-inline-block"
              placeholder="客户名称"
            />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="关联项目" style="margin-bottom: 0;">
              <b-form-input
                v-model="searchParams.projectName"
                class="d-inline-block"
                placeholder="关联项目"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="推介单号" style="margin-bottom: 0;">
              <b-form-input
                v-model="searchParams.customerOrderSN"
                class="d-inline-block"
                placeholder="推介单号"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" lg="4" xl="3" class="mb-md-0 my-1">
            <b-form-group label-cols="auto" label="客户状态" style="margin-bottom: 0;">
            <v-select
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="searchParams.status"
              :options="statusOptions"
              class="w-100"
              :reduce="val => val.value"
            />
            </b-form-group>
          </b-col>

          <!-- <b-col class="d-flex justify-content-end">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="success"
              class="mt-1"
            >
              导出
            </b-button>
          </b-col> -->
        </b-row>
      </b-card-body>
    </b-card>

    <b-row class="d-flex justify-content-between">
      <b-col cols="12" md="6" lg="3">
      <b-card no-body class="mb-1" :class="searchParams.status === 0 ? 'card-border' : ''" @click="searchParams.status = 0">
        <b-card-body class="py-1">
              <b-media no-body>
                <b-media-aside class="mr-2">
                  <b-avatar size="48" variant="light-warning">
                    <feather-icon size="24" icon="BoxIcon"/>
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto">
                  <h4 class="font-weight-bolder mb-0"> {{ statistic.totalNum }} </h4>
                  <b-card-text class="font-small-3 mb-0"> 全部 </b-card-text>
                </b-media-body>
              </b-media>
        </b-card-body>
      </b-card>
      </b-col>
      <b-col cols="12" md="6" lg="3">
      <b-card no-body class="mb-1" @click="searchParams.status = 1" :class="searchParams.status === 1 ? 'card-border' : ''">
        <b-card-body class="py-1">
              <b-media no-body>
                <b-media-aside class="mr-2">
                  <b-avatar size="48" variant="light-info">
                    <feather-icon size="24" icon="NavigationIcon"/>
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto">
                  <h4 class="font-weight-bolder mb-0"> {{ statistic.recommendedNum }} </h4>
                  <b-card-text class="font-small-3 mb-0"> 已到访 </b-card-text>
                </b-media-body>
              </b-media>
        </b-card-body>
      </b-card>
      </b-col>
      <b-col cols="12" md="6" lg="3">
      <b-card no-body class="mb-1" @click="searchParams.status = 2" :class="searchParams.status === 2 ? 'card-border' : ''">
        <b-card-body class="py-1">
              <b-media no-body>
                <b-media-aside class="mr-2">
                  <b-avatar size="48" variant="light-info">
                    <feather-icon size="24" icon="NavigationIcon"/>
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto">
                  <h4 class="font-weight-bolder mb-0"> {{ statistic.signedNum }} </h4>
                  <b-card-text class="font-small-3 mb-0"> 已签约 </b-card-text>
                </b-media-body>
              </b-media>
        </b-card-body>
      </b-card>
      </b-col>
      <b-col cols="12" md="6" lg="3">
      <b-card no-body class="mb-1" @click="searchParams.status = 3" :class="searchParams.status === 3 ? 'card-border' : ''">
        <b-card-body class="py-1">
              <b-media no-body>
                <b-media-aside class="mr-2">
                  <b-avatar size="48" variant="light-success">
                    <feather-icon size="24" icon="CheckSquareIcon"/>
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto">
                  <h4 class="font-weight-bolder mb-0"> {{ statistic.succeedNum }} </h4>
                  <b-card-text class="font-small-3 mb-0"> 推介成功 </b-card-text>
                </b-media-body>
              </b-media>
        </b-card-body>
      </b-card>
      </b-col>
    </b-row>

    <b-card>
      <b-row class="mb-50">
        <b-col cols="12" md="6" class="mb-md-0 d-flex">
          <b-button-group size="sm">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              @click="visible_coumn = true"
            > 全量 </b-button>
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              :pressed="!visible_coumn"
              @click="visible_coumn = false"
            > 精简 </b-button>
          </b-button-group>
        </b-col>
        <!-- :to="{ name: 'order-new'}" -->
        <!-- <b-col cols="12" md="6" class="mb-md-0 d-flex justify-content-end align-items-end">
          <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="primary"> 新建经纪人客户 </b-button>
        </b-col> -->
      </b-row>

      <!-- table -->
      <vxe-table
        ref="xTable"
        border
        :column-config="{resizable: true}"
        :auto-resize="true"
        :data="tableData"
        keep-source
        highlight-current-row
        :loading="loading"
        :cell-class-name="cellClassName"
        :scroll-x="{enabled: true}"
        :scroll-y="{enabled: true}"
      >
        <vxe-table-column field="id" title="ID" width="80" align="center"></vxe-table-column>
        <vxe-table-column field="projectName" title="成交项目" min-width="180" show-overflow></vxe-table-column>
        <vxe-table-column field="customerName" title="客户名称" width="180" show-overflow></vxe-table-column>
        <vxe-table-column field="contactsName" title="客户联系人" width="100" show-overflow align="center"></vxe-table-column>
        <vxe-table-column field="contactsPhone" title="客户联系方式" width="140" show-overflow align="center"></vxe-table-column>
        <vxe-table-column field="createdAt" title="创建时间" width="180" :visible="visible_coumn" align="center"></vxe-table-column>
        <vxe-table-column field="brokerName" title="所属经纪人" width="100" show-overflow align="center"></vxe-table-column>
        <vxe-table-column field="customerOrderSn" title="推介单号" width="150" align="center" show-overflow :visible="visible_coumn"></vxe-table-column>
        <vxe-table-column field="expired" title="到期释放时间" width="180" align="center" show-overflow :visible="visible_coumn"></vxe-table-column>
        <vxe-table-column field="expiredDay" title="保护期(天)" width="100" align="center" show-overflow>
          <template v-slot="{ row }">
            <div style="color: red;">{{ [1,2].includes(row.status) ? row.expiredDay : '未锁定' }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="releaseStatusTxt" title="释放时状态" width="110" align="center" show-overflow>
          <template v-slot="{ row }">
            <b-badge pill v-if="row.releaseStatus === 1" class="px-1 py-50" variant="light-success"> 已到访 </b-badge>
            <b-badge pill v-else-if="row.releaseStatus === 2" class="px-1 py-50" variant="light-info"> 已签约 </b-badge>
            <div v-else>--</div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="releaseTime" title="实际释放时间" width="180" align="center" show-overflow>
          <template v-slot="{ row }">
            <div>{{ row.releaseTime && JSON.stringify(row.releaseTime) !== '{}' ? row.releaseTime : '--' }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="customerContents" title="客户附件" min-width="150" align="center" show-overflow>
          <template v-slot="{ row }">
            <viewer>
              <b-img v-for="(item,index) in row.customerContents" :key="index" :src="item" height="32" width="32" class="d-inline-block mx-50"/>
            </viewer>
          </template>
        </vxe-table-column>
        <vxe-table-column field="status" title="单据状态" width="100" align="center">
          <template v-slot="{ row }">
            <b-badge pill v-if="row.status === 1" class="px-1 py-50" variant="light-success"> 已到访 </b-badge>
            <b-badge pill v-else-if="row.status === 2" class="px-1 py-50" variant="light-info"> 已签约 </b-badge>
            <b-badge pill v-else-if="row.status === 3" class="px-1 py-50" variant="light-primary"> 推介成功 </b-badge>
            <b-badge pill v-else-if="row.status === 4" class="px-1 py-50" variant="light-warning"> 已释放 </b-badge>
          </template>
        </vxe-table-column>
        <vxe-table-column field="action" title="操作" align="center" fixed="right" width="160">
          <template v-slot="{ row }">
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-if="row.status === 1 && $can('sign', 'broker-customer')"
                variant="flat-primary" class="btn-icon" size="sm" @click="signEvent(row.id)"
              >
                <!-- <feather-icon icon="FeatherIcon" class="cursor-pointer text-body" size="16" /> -->
                签约
            </b-button>
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-if="row.status === 1 && $can('days', 'broker-customer')"
                variant="flat-primary" class="btn-icon" size="sm" @click="upDays_id = row.id, upDays_show = true"
              >
                <!-- <feather-icon icon="GitPullRequestIcon" class="cursor-pointer text-body" size="16" /> -->
                保护期
            </b-button>
            <b-button
                v-ripple.400="'rgba(113, 102, 240, 0.15)'" v-if="(row.status == 1 || row.status == 2) && $can('release', 'broker-customer')"
                variant="flat-primary" class="btn-icon" size="sm" @click="releaseEvent(row.id)"
              >
                <!-- <feather-icon icon="LogOutIcon" class="cursor-pointer text-body" size="16" /> -->
                释放
            </b-button>
          </template>
        </vxe-table-column>
      </vxe-table>

      <div class="d-flex justify-content-between flex-wrap">
        <div class="d-flex align-items-center mb-0 mt-1">
          <Select v-model="searchParams.size" class="mr-1">
            <Option v-for="item in pageOptions" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <span class="text-nowrap"> 共 {{ total }} 条记录 </span>
        </div>
        <div class="d-flex align-items-center">
          <b-pagination v-model="searchParams.page" :total-rows="total" :per-page="searchParams.size" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0">
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
          <div class="d-flex align-items-center mb-0 mt-1 ml-1">
            <span class="text-nowrap">跳至</span>
            <Input @on-enter="pageToChange"
              v-model="pageTo" type="number" number class="mx-1" style="width: 5rem;"/>
            <span class="text-nowrap">页</span>
          </div>
        </div>
      </div>
    </b-card>

    <updateDays v-model="upDays_show" :id="upDays_id" @up-days="upDays" />
  </div>

</template>

<script>
import vSelect from 'vue-select'
import { ref, watch, onMounted, nextTick } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { brokerCustomerListApi, brokerCustomerUpdateDaysApi, brokerCustomerSignApi, brokerCustomerReleaseApi } from '@/api/broker/brokerCustomer.js'
// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import updateDays from './updateDays.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    BCardActions,
    updateDays,
  },
  setup(props, context) {
    /* 必要组件加载区域 */

    // 权限组件 弹出确认组件
    const { $can, $swal } = context.root
    // 消息提醒组件
    const toast = useToast()

    /* 组件页面数据准备区域，包括表单，下拉选择项，数据整理操作等 */
    // 表格加载控制 表格数据
    const loading = ref(false)
    const tableData = ref([])
    // 页码选择
    const pageOptions = ref([
      { label: '10 条/页', value: 10 },
      { label: '20 条/页', value: 20 },
      { label: '50 条/页', value: 50 },
    ])
    // 状态条件
    const statusOptions = ref([
      { label: '全部', value: 0 },
      { label: '已到访', value: 1 },
      { label: '已签约', value: 2 },
      { label: '推介成功', value: 3 },
      { label: '已释放', value: 4 },
    ])
    // 统计数据
    const statistic = ref({ recommendedNum: 0, signedNum: 0, totalNum: 0, succeedNum: 0, releasedNum: 0 })

    // 数量
    const total = ref(0)
    // 控制多余表数据显示否
    const visible_coumn = ref(false)
    // 表格对象DOM
    const xTable = ref(null)
    // 查询条件
    
    const searchParams = ref({
      page: 1, size: 10,
      brokerName: '', contactsName	: '', contactsPhone: '', customerName: '', status: 0, projectName: '', customerOrderSN: ''
    })
    const pageTo = ref(null)
    // 指定页码操作
    const pageToChange = () => {
      const count = Math.ceil(total.value / searchParams.value.size)
      if (pageTo.value < 1) {
        pageTo.value = 1
      } else if (pageTo.value > count) {
        pageTo.value = count
      } else {
        pageTo.value = parseInt(pageTo.value, 0)
      }
      searchParams.value.page = pageTo.value
    }
    // 延长保护期操作
    const upDays_id = ref(null)
    const upDays_show = ref(false)


    /* 接口调用区域 */
    const cellClassName = ({ column }) => { if (column.property === 'action' || column.property === 'status') { return 'vxe-table-padding' } }

    // 获取列表
    const fetchData = () => {
      brokerCustomerListApi(searchParams.value)
        .then(res => {
          tableData.value = res.data.list
          total.value = res.data.total
          statistic.value = res.data.statistic
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: { title: '获取经纪人客户列表信息失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
    }

    // 签约操作
    const signEvent = id => {
      $swal({
        title: '签约确认',
        text: '是否将客户状态变更为已签约状态?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          brokerCustomerSignApi({id})
            .then(() => {
              fetchData()
              toast({
                component: ToastificationContent,
                props: { title: '签约成功', icon: 'CheckCircleIcon', variant: 'success' },
              })
            })
            .catch(err => {
              toast({
                component: ToastificationContent,
                props: { title: '签约失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
              })
            })
        }
      })
    }

    // 释放操作
    const releaseEvent = id => {
      $swal({
        title: '释放确认',
        text: '确定解除客户锁定状态,释放客户资源吗?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          brokerCustomerReleaseApi({id})
            .then(() => {
              fetchData()
              toast({
                component: ToastificationContent,
                props: { title: '释放成功', icon: 'CheckCircleIcon', variant: 'success' },
              })
            })
            .catch(err => {
              toast({
                component: ToastificationContent,
                props: { title: '释放失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
              })
            })
        }
      })
    }

    // 延长保护期
    const upDays = (id, days) => {
      brokerCustomerUpdateDaysApi({id, days})
        .then(res => {
          fetchData()
          toast({
            component: ToastificationContent,
            props: { title: '保护期延长操作成功', icon: 'CheckCircleIcon', variant: 'success' },
          })
        })
        .catch(err => {
          toast({
            component: ToastificationContent,
            props: { title: '保护期延长操作失败', text: err.msg, icon: 'AlertTriangleIcon', variant: 'danger' },
          })
        })
    }

    // 条件筛选 下拉选择分类 选择项

    /* 组件内部逻辑处理，生命周期问题处理区域 */

    // 处理基本下拉信息加载，权限判断等
    onMounted(() => {
      if ($can('list', 'broker-customer')) {
        fetchData()
      } else {
        toast({
          component: ToastificationContent,
          props: { title: '您没有经纪人客户列表的权限', icon: 'AlertTriangleIcon', variant: 'danger' },
        })
      }
    })

    // 刷新查询
    watch(searchParams.value, () => { fetchData() })

    // 表格数据显示方式
    watch(visible_coumn, () => {
      nextTick(() => { xTable.value.refreshColumn() })
    })

    return {
      loading,
      tableData,
      total,
      xTable,

      pageOptions,
      searchParams,
      pageTo,
      pageToChange,
      statusOptions,

      fetchData,

      visible_coumn,
      // 审核相关
      upDays_id,
      upDays_show,

      signEvent,
      releaseEvent,
      upDays,

      statistic,
      cellClassName,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
